module.exports = __webpack_public_path__ + "img/GradingPlans.46eaaab8.svg";